import { useState, useEffect } from "react";
import { BRAND } from "../constants";

function AdminGear() {
  return (
    <a href="/admin" target="_blank" rel="noopener noreferrer" style={{
      position: "absolute",
      top: "8px",
      left: "10px",
      zIndex: 2,
      opacity: 0.25,
      transition: "opacity 0.2s ease",
    }}
      onMouseOver={function(e) { e.currentTarget.style.opacity = "0.5"; }}
      onMouseOut={function(e) { e.currentTarget.style.opacity = "0.25"; }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.8)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    </a>
  );
}

function DotPattern() {
  return (
    <div style={{
      position: "absolute", inset: 0, opacity: 0.08,
      backgroundImage: "radial-gradient(circle, #fff 1.5px, transparent 1.5px)",
      backgroundSize: "20px 20px",
    }} />
  );
}

function Starburst({ count, size }) {
  var scale = (size || 110) / 110;
  var spikes = 18;
  var outerR = 100;
  var innerR = 76;
  var pts = [];
  for (var i = 0; i < spikes * 2; i++) {
    var r = i % 2 === 0 ? outerR : innerR;
    var angle = (Math.PI * i / spikes) - Math.PI / 2;
    pts.push((100 + r * Math.cos(angle)).toFixed(1) + "," + (100 + r * Math.sin(angle)).toFixed(1));
  }

  return (
    <div style={{
      width: (110 * scale) + "px",
      height: (110 * scale) + "px",
      flexShrink: 0,
      transform: "rotate(18deg)",
      position: "relative",
    }}>
      <svg viewBox="0 0 200 200" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", filter: "drop-shadow(0 4px 14px rgba(0,0,0,0.3))" }}>
        <polygon
          points={pts.join(" ")}
          fill={BRAND.gold}
          stroke="#E5AB3A"
          strokeWidth="2"
        />
      </svg>
      <div style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        transform: "rotate(0deg) translateY(-4px)",
      }}>
        <div style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: (42 * scale) + "px",
          fontWeight: 800,
          color: "#fff",
          lineHeight: 1,
          textShadow: "0 2px 6px rgba(0,0,0,0.25)",
        }}>
          {count}
        </div>
        <div style={{
          fontSize: (10 * scale) + "px",
          fontWeight: 700,
          color: "rgba(255,255,255,0.95)",
          textTransform: "uppercase",
          letterSpacing: "1.2px",
          marginTop: (6 * scale) + "px",
          textShadow: "0 1px 3px rgba(0,0,0,0.2)",
        }}>
          Tributes
        </div>
      </div>
    </div>
  );
}

function useIsMobile(breakpoint) {
  var [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < breakpoint
  );
  useEffect(function () {
    function onResize() { setIsMobile(window.innerWidth < breakpoint); }
    window.addEventListener("resize", onResize);
    return function () { window.removeEventListener("resize", onResize); };
  }, [breakpoint]);
  return isMobile;
}

/* Compact purple bar: title — stays sticky */
export function HeaderBar() {
  var isMobile = useIsMobile(768);

  return (
    <div style={{
      background: BRAND.primary,
      padding: isMobile ? "10px 14px" : "12px 24px",
      position: "relative",
      overflow: "hidden",
    }}>
      <DotPattern />
      <AdminGear />
      <div style={{
        position: "relative", zIndex: 1,
        maxWidth: "1200px", margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px",
      }}>
        <div>
          <div style={{ fontSize: isMobile ? "9px" : "10px", color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "1px" }}>
            Decatur Education Foundation
          </div>
          <h1 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: isMobile ? "20px" : "clamp(24px, 3vw, 32px)",
            color: "#fff",
            margin: 0,
            fontWeight: 800,
            lineHeight: 1.15,
          }}>
            Step Up for Teachers
          </h1>
        </div>
      </div>
    </div>
  );
}

/* Full description + yard sign images — scrolls away */
export function HeaderDetails() {
  var isMobile = useIsMobile(768);

  if (isMobile) {
    return (
      <div style={{
        background: BRAND.primary,
        padding: "0 14px 16px",
        position: "relative",
        overflow: "hidden",
      }}>
        <DotPattern />
        <div style={{ position: "relative", zIndex: 1, padding: "0 8px", textAlign: "center" }}>
          <p style={{
            color: "rgba(255,255,255,0.88)",
            fontSize: "13px",
            margin: "0 0 8px",
            lineHeight: 1.55,
          }}>
            Thanks to everyone who participated in the DEF 2026 Step Up for Teachers campaign. This program allows members of the community to show appreciation for CSD teachers/staff and show pride in graduating seniors by having a yard sign in their honor. Tributes are shared on this wall which is searchable by teacher or family name and can be sorted by school.
          </p>
          <p style={{
            color: "rgba(255,255,255,0.7)",
            fontSize: "12px",
            margin: "0 0 12px",
            lineHeight: 1.5,
            fontStyle: "italic",
          }}>
            Proceeds from DEF{"\u2019"}s Step Up Campaign fund Teacher and Student Innovation Grants in all CSD Schools. Read more about DEF Innovation Grants at <a href="https://www.decatureducationfoundation.org/innovation-grants" target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.85)", textDecoration: "underline" }}>decatureducationfoundation.org/innovation-grants</a>.
          </p>

          {/* Yard sign images */}
          <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
            <img
              src="/signs/senior-sign-2026-email-2.jpeg"
              alt="Congratulations Class of 2026 yard sign"
              style={{ height: "70px", borderRadius: "4px", border: "2px solid #fff", boxShadow: "0 2px 6px rgba(0,0,0,0.3)" }}
            />
            <img
              src="/signs/step-up-for-teachers-2026.jpeg"
              alt="We Step Up for CSD Teachers + Staff yard sign"
              style={{ height: "70px", borderRadius: "4px", border: "2px solid #fff", boxShadow: "0 2px 6px rgba(0,0,0,0.3)" }}
            />
          </div>
        </div>
      </div>
    );
  }

  // Desktop
  return (
    <div style={{
      background: BRAND.primary,
      padding: "0 24px 20px",
      position: "relative",
      overflow: "hidden",
    }}>
      <DotPattern />
      <div style={{
        position: "relative", zIndex: 1, maxWidth: "1200px", margin: "0 auto",
        display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "28px",
      }}>
        {/* Left: full instructions */}
        <div style={{ flex: "1 1 0", minWidth: 0 }}>
          <p style={{
            color: "rgba(255,255,255,0.88)",
            fontSize: "15px",
            margin: 0,
            lineHeight: 1.55,
          }}>
            Thanks to everyone who participated in the DEF 2026 Step Up for Teachers campaign. This program allows members of the community to show appreciation for CSD teachers/staff and show pride in graduating seniors by having a yard sign in their honor. Tributes are shared on this wall which is searchable by teacher or family name and can be sorted by school.
          </p>
          <p style={{
            color: "rgba(255,255,255,0.7)",
            fontSize: "14px",
            lineHeight: 1.5,
            margin: "10px 0 0",
            fontStyle: "italic",
          }}>
            Proceeds from DEF{"\u2019"}s Step Up Campaign fund Teacher and Student Innovation Grants in all CSD Schools. Read more about DEF Innovation Grants at <a href="https://www.decatureducationfoundation.org/innovation-grants" target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.85)", textDecoration: "underline" }}>decatureducationfoundation.org/innovation-grants</a>.
          </p>
        </div>

        {/* Right: yard sign images */}
        <div style={{ flexShrink: 0, display: "flex", gap: "10px", alignSelf: "center" }}>
          <img
            src="/signs/senior-sign-2026-email-2.jpeg"
            alt="Congratulations Class of 2026 yard sign"
            style={{ height: "95px", borderRadius: "4px", border: "2px solid #fff", boxShadow: "0 2px 8px rgba(0,0,0,0.3)" }}
          />
          <img
            src="/signs/step-up-for-teachers-2026.jpeg"
            alt="We Step Up for CSD Teachers + Staff yard sign"
            style={{ height: "95px", borderRadius: "4px", border: "2px solid #fff", boxShadow: "0 2px 8px rgba(0,0,0,0.3)" }}
          />
        </div>
      </div>
    </div>
  );
}

/* Default export kept for backwards compat — renders both parts together */
export default function Header({ tributeCount, onStepUp }) {
  return (
    <>
      <HeaderBar onStepUp={onStepUp} />
      <HeaderDetails />
    </>
  );
}
